export default __webpack_public_path__ + "static/media/fortress-skid-plate.8ae10324.glb";